import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  Input,
  forwardRef
} from '@angular/core';

import { NotificationModel }    from './typings/notification';
import { NotificationsService } from './notifications.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector       : 'wor-notifications',
  template: require('./notifications.component.html')
})
export class NotificationsComponent {
  _notifications : Array<NotificationModel>;

  @Input() type = 'info';

  @Input() set notifications ( _notifications : Array<NotificationModel> ) {
    this._notifications = this.notificationsService.formatNotifications(_notifications);
  }

  constructor (
    @Inject(forwardRef(() => NotificationsService)) private notificationsService: NotificationsService,
  ) {}

  dismiss ( notification : NotificationModel ) : void {
    this.notificationsService.dismiss(notification);

    this._notifications = this.notificationsService.formatNotifications(this._notifications);
  }
}
